import { NavLink, LinkProps } from 'react-router-dom'
import { useRedirectAnimation } from 'hooks'

type DelayLinkProps = LinkProps & {
  disabled?: boolean
  delay: number
  to: string
  dataTest?: string
}

const DelayNavLink: React.FC<DelayLinkProps> = props => {
  const { delay, to, children, className, dataTest } = props
  const handleRedirectAnimation = useRedirectAnimation({ to, delay })

  return (
    <NavLink
      children={children}
      className={className}
      to={to}
      onClick={handleRedirectAnimation}
      data-test={dataTest}
    />
  )
}

export default DelayNavLink
